<template>
  <div>
    <ResumeRoom style="margin-bottom: 2%;"></ResumeRoom>
    <v-card>
      <v-tabs
          v-model="tab"
          centered
          icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          En service
          <v-icon>mdi-phone</v-icon>
        </v-tab>

        <v-tab href="#tab-2">
          Occuper
          <v-icon>mdi-heart</v-icon>
        </v-tab>

        <v-tab href="#tab-3">
          Hors Service
          <v-icon>mdi-account-box</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
            :value="'tab-' + 1"
        >
          <v-row style="margin-top: 2%;padding-left: 1%;padding-right: 1%;">
            <v-col
                v-for="room in room_avaible"
                :key="room.id"
                class="align-self-start"
                cols="12"
                md="4"
                sm="6"
            >
              <v-card>
                <v-img
                    :src="photosRoom(room.room_photos)[0]"
                    height="250"
                ></v-img>
                <v-card-title>
                  {{ room.room_name }}
                </v-card-title>
                <v-card-text>
                  Prix: {{ room.room_total_price }} Type: {{ room.room_type.room_type_name }}
                </v-card-text>
                <v-card-actions class="dense">
                  <v-btn
                      color="primary"
                      text
                  >
                    Details
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      @click="room.show_detail = !room.show_detail"
                  >
                    <v-icon>
                      {{
                        room.show_detail ? icons.mdiChevronUp : icons.mdiChevronDown
                      }}
                    </v-icon>
                  </v-btn>
                </v-card-actions>
                <v-expand-transition>
                  <div v-show="room.show_detail">
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row>
                        <div class="pt-5">
                          <div class="text-center mb-3">
                            <v-btn
                                color="primary"
                                depressed
                                @click="showEditRoomDialog(room)"
                            >
                              Mettre à jour &ensp;
                              <v-icon>
                                {{ icons.mdiCommentEditOutline }}
                              </v-icon>
                            </v-btn>
                          </div>
                          <div>
                            <span class="big-title mark uppercase">Code &emsp; </span>
                            <span class="big-title mark important">{{ room.room_name }}</span>
                          </div>
                          <div>
                            <span class="big-title mark uppercase">Prix &emsp; </span>
                            <span class="big-title important mark">{{ room.room_unit_price }} FCFA</span>
                          </div>
                          <div>
                            <span class="big-title mark uppercase">Appartement &emsp; </span>
                            <span class="big-title important mark">{{ room.apartment.apart_bloc }}</span>
                          </div>
                          <div>
                            <span class="big-title mark uppercase d-block">Date de création </span>
                            <span class="big-title important mark">{{ room.room_create_date }}</span>
                          </div>
                          <div>
                            <span class="big-title mark uppercase">Type de chambre &emsp; </span>
                            <span class="big-title important mark">{{ room.room_type.room_type_name }}</span>
                          </div>
                          <div>
                            <span class="big-title mark uppercase">Toutes les images &emsp; </span>
                            <span
                                class="big-title important mark d-block d-flex justify-space-between align-content-center"
                            >
                              <v-btn
                                  color="primary"
                                  depressed
                                  @click="showMore(room.room_photos)"
                              >
                                Voir&ensp;<v-icon>
                                  {{ icons.mdiEye }}
                                </v-icon>
                              </v-btn>
                            </span>
                          </div>
                        </div>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
            :value="'tab-' + 2"
        >
          <v-row style="margin-top: 2%;padding-left: 1%;padding-right: 1%;">
            <v-col
                v-for="room in room_buzy"
                :key="room.id"
                class="align-self-start"
                cols="12"
                md="4"
                sm="6"
            >
              <v-card>
                <v-img
                    :src="photosRoom(room.room_photos)[0]"
                    height="250"
                ></v-img>
                <v-card-title>
                  {{ room.room_name }}
                </v-card-title>
                <v-card-text>
                  Prix: {{ room.room_total_price }} Type: {{ room.room_type.room_type_name }}
                </v-card-text>
                <v-card-actions class="dense">
                  <v-btn
                      color="primary"
                      text
                  >
                    Details
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      @click="isCardDetailsVisible = !isCardDetailsVisible"
                  >
                    <v-icon>
                      {{
                        isCardDetailsVisible ? icons.mdiChevronUp : icons.mdiChevronDown
                      }}
                    </v-icon>
                  </v-btn>
                </v-card-actions>
                <v-expand-transition>
                  <div v-show="isCardDetailsVisible">
                    <v-divider></v-divider>
                    <v-card-text>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
            :value="'tab-' + 3"
        >
          <v-row style="margin-top: 2%;padding-left: 1%;padding-right: 1%;">
            <v-col
                v-for="room in room_off"
                :key="room.id"
                class="align-self-start"
                cols="12"
                md="4"
                sm="6"
            >
              <v-card>
                <v-img
                    :src="photosRoom(room.room_photos)[0]"
                    height="250"
                ></v-img>
                <v-card-title>
                  {{ room.room_name }}
                </v-card-title>
                <v-card-text>
                  Prix: {{ room.room_total_price }} Type: {{ room.room_type.room_type_name }}
                </v-card-text>
                <v-card-actions class="dense">
                  <v-btn
                      color="primary"
                      text
                  >
                    Details
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      @click="isCardDetailsVisible = !isCardDetailsVisible"
                  >
                    <v-icon>
                      {{
                        isCardDetailsVisible ? icons.mdiChevronUp : icons.mdiChevronDown
                      }}
                    </v-icon>
                  </v-btn>
                </v-card-actions>
                <v-expand-transition>
                  <div v-show="isCardDetailsVisible">
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <div>
      <UpdateRoom
          :active="editRoomDialog"
          :room-to-update.sync="currentRoom"
          @close-edit="closeEditRoomDialog"></UpdateRoom>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import {
  mdiAccountOutline,
  mdiCartPlus,
  mdiChevronDown,
  mdiChevronUp,
  mdiClose,
  mdiCommentEditOutline,
  mdiEye,
  mdiHelpCircleOutline,
  mdiLockOpenOutline,
  mdiShareVariantOutline,
  mdiStarOutline,
  mdiTrendingUp,
} from '@mdi/js'
// eslint-disable-next-line import/extensions,import/no-unresolved
import ResumeRoom from '@/views/rooms/ResumeRoom'
import * as components from 'vuetify'
import UpdateRoom from '@/views/rooms/UpdateRoom.vue';

export default {
  name: 'RoomList',
  components: {
    UpdateRoom,
    ResumeRoom,
  },
  setup() {
    const isCardDetailsVisible = false
    const rating = ref(5)

    return {
      isCardDetailsVisible,
      rating,
      tab: null,
      text: 'en cours de dev',

      // icons
      icons: {
        mdiChevronUp,
        mdiChevronDown,
        mdiCartPlus,
        mdiShareVariantOutline,
        mdiLockOpenOutline,
        mdiStarOutline,
        mdiAccountOutline,
        mdiTrendingUp,
        mdiHelpCircleOutline,
        mdiEye,
        mdiCommentEditOutline,
        mdiClose,
      },
    }
  },
  data() {
    return {
      list_room: [],
      room_avaible: [],
      currentRoom: {},
      tempCurrentRoom: {},
      editRoomDialog: false,
      room_buzy: [],
      room_off: [],
    }
  },

  mounted() {
    this.loadRoom()
  },
  methods: {
    loadRoom() {
      this.$axios.get(this.$endpoint.LoadRoom).then(rp => {
        this.roomSetData(rp.data)
      })
    },
    roomSetData(data) {
      this.list_room = []
      data.forEach(r => {
        const tempRoom = r
        tempRoom.show_detail = false
        this.list_room.push(tempRoom)
      })
      this.room_avaible = this.list_room.filter(room => room.room_status === 400)
      this.room_buzy = this.list_room.filter(room => room.room_status === 450)
      this.room_off = this.list_room.filter(room => room.room_status === 500)
    },

    photosRoom(imgtable) {
      const finaltable = []
      if (imgtable) {
        // const source = imgtable.split('')
        imgtable.forEach(src => {
          finaltable.push(`${process.env.VUE_APP_API_ASSET_URL}${src}`)
        })
      }

      return finaltable
    },
    showMore(roomImages) {
      this.$viewerApi({
        images: this.photosRoom(roomImages),
      })
    },
    showSigleImage(image) {
      const images = [image]
      this.$viewerApi({
        images,
      })
    },
    showEditRoomDialog(room) {
      this.editRoomDialog = !this.editRoomDialog
      this.currentRoom = room
    },
    closeEditRoomDialog() {
      this.loadRoom()
      this.editRoomDialog = false
    },
  },
}
</script>
<style scoped>
.v-toolbar {
  flex: none;
}

.viewer-button {
  z-index: 99999;
}
</style>
